// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-K4MVs";
var _3 = "header-1dEqC";
export { _1 as "__esModule", _2 as "root", _3 as "header" }
export default { "__esModule": _1, "root": _2, "header": _3 }
